import { render } from "./AnalyticalModelConfig.vue?vue&type=template&id=2f96b14c&scoped=true&ts=true"
import script from "./AnalyticalModelConfig.vue?vue&type=script&lang=ts"
export * from "./AnalyticalModelConfig.vue?vue&type=script&lang=ts"

import "./AnalyticalModelConfig.vue?vue&type=style&index=0&id=2f96b14c&lang=scss&scoped=true"

import exportComponent from "/home/vsts/work/1/s/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2f96b14c"]])

export default __exports__